
export const PAGE_OPT = {
    LIST: {
        pg_rowsize: 8,
        pageNo: 1,
        pageCountOfGroup: 5
    },
    PREVIEW: {
        pg_rowsize: 8,
        pageNo: 1,
    }
}

export const SEARCH_OPT = {
    LIST: {
        type: null,
        searchValue: null,
    },
    PREVIEW: {
        type: null,
        searchValue: null,
    }
}
